export const ruleEngineRouteDef = [
    {
        path: ':id/:resource/expressionbuilder',
        component: 'ExpessionBuilderComponent',
        data: {
            selector: 'app-expession-builder'
        }
    }
]